var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFirefoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 2.02L14 2C11.8 2 10 3.8 10 6V42C10 44.2 11.8 46 14 46H34C36.2 46 38 44.2 38 42V6C38 3.8 36.2 2.02 34 2.02ZM34 38H14V10H34V38Z",
    fill: "#495058"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_256_892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.42 21.3725C31.072 20.5617 30.3661 19.6862 29.8132 19.4095C30.2074 20.1487 30.4811 20.9425 30.6244 21.7627L30.6258 21.7757C29.7202 19.5906 28.1852 18.7081 26.9308 16.7891C26.8673 16.6921 26.8039 16.5948 26.7421 16.4921C26.7068 16.4335 26.6784 16.3807 26.6539 16.3321C26.6018 16.2345 26.5617 16.1314 26.5344 16.0249C26.5344 16.02 26.5326 16.0152 26.5293 16.0115C26.5259 16.0078 26.5213 16.0055 26.5162 16.0049C26.5113 16.0036 26.5061 16.0036 26.5011 16.0049C26.5001 16.0049 26.4984 16.0067 26.4972 16.0071C26.496 16.0075 26.4933 16.0093 26.4914 16.0101L26.4945 16.0049C24.4827 17.1455 23.7997 19.2566 23.7377 20.3132C22.934 20.3665 22.1656 20.6532 21.5327 21.1358C21.4666 21.0817 21.3977 21.031 21.326 20.9841C21.1435 20.3656 21.1357 19.711 21.3035 19.0885C20.5646 19.4351 19.9081 19.9264 19.3756 20.5313H19.3718C19.0544 20.1417 19.0767 18.857 19.0949 18.5887C19.001 18.6252 18.9114 18.6713 18.8275 18.7261C18.5473 18.9198 18.2853 19.1371 18.0447 19.3755C17.7705 19.6447 17.52 19.9356 17.296 20.2453V20.2465V20.2451C16.7811 20.9518 16.4158 21.7503 16.2213 22.5944L16.2106 22.6456C16.1955 22.7138 16.1411 23.0556 16.1318 23.1299C16.1318 23.1357 16.1306 23.1411 16.13 23.1469C16.0599 23.4997 16.0164 23.8571 16 24.216V24.2561C16.0035 26.1968 16.7584 28.0657 18.1154 29.4939C19.4725 30.9221 21.3332 31.8058 23.3303 31.9705C25.3273 32.1352 27.3156 31.5689 28.9026 30.3836C30.4895 29.1982 31.5599 27.4798 31.9024 25.5676C31.9158 25.4675 31.9267 25.3684 31.9387 25.2674C32.1037 23.9471 31.9251 22.6078 31.4192 21.3713L31.42 21.3725ZM22.1886 27.4437C22.226 27.4612 22.2611 27.48 22.2996 27.4966L22.3051 27.5C22.2663 27.482 22.2274 27.4632 22.1886 27.4437ZM30.626 21.7779V21.7705L30.6275 21.7787L30.626 21.7779Z",
    fill: "url(#paint0_linear_256_892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4198 21.3722C31.0718 20.5614 30.3659 19.6859 29.8131 19.4092C30.2073 20.1484 30.4809 20.9422 30.6242 21.7624V21.7698L30.6256 21.778C31.2431 23.4888 31.1538 25.3644 30.3764 27.0128C29.4584 28.92 27.2373 30.8748 23.7592 30.7788C20.0022 30.6757 16.6915 27.9753 16.0736 24.4394C15.961 23.8817 16.0736 23.599 16.1302 23.1458C16.053 23.4978 16.0099 23.8561 16.0015 24.2159V24.2559C16.005 26.1967 16.7598 28.0656 18.1169 29.4938C19.474 30.922 21.3347 31.8057 23.3318 31.9704C25.3288 32.1351 27.3171 31.5688 28.904 30.3834C30.491 29.198 31.5614 27.4796 31.9038 25.5674C31.9172 25.4674 31.9282 25.3683 31.9402 25.2673C32.1052 23.947 31.9266 22.6077 31.4206 21.3712L31.4198 21.3722Z",
    fill: "url(#paint1_radial_256_892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4198 21.3722C31.0718 20.5614 30.3659 19.6859 29.8131 19.4092C30.2073 20.1484 30.4809 20.9422 30.6242 21.7624V21.7698L30.6256 21.778C31.2431 23.4888 31.1538 25.3644 30.3764 27.0128C29.4584 28.92 27.2373 30.8748 23.7592 30.7788C20.0022 30.6757 16.6915 27.9753 16.0736 24.4394C15.961 23.8817 16.0736 23.599 16.1302 23.1458C16.053 23.4978 16.0099 23.8561 16.0015 24.2159V24.2559C16.005 26.1967 16.7598 28.0656 18.1169 29.4938C19.474 30.922 21.3347 31.8057 23.3318 31.9704C25.3288 32.1351 27.3171 31.5688 28.904 30.3834C30.491 29.198 31.5614 27.4796 31.9038 25.5674C31.9172 25.4674 31.9282 25.3683 31.9402 25.2673C32.1052 23.947 31.9266 22.6077 31.4206 21.3712L31.4198 21.3722Z",
    fill: "url(#paint2_radial_256_892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5264 22.2827C27.5437 22.2945 27.5598 22.3064 27.5762 22.3182C27.375 21.9727 27.1245 21.6564 26.8322 21.3787C24.342 18.9674 26.1798 16.1519 26.4896 16.0078L26.4927 16.0034C24.4808 17.144 23.7978 19.2551 23.7358 20.3117C23.8292 20.3055 23.9218 20.2979 24.0173 20.2979C24.7311 20.2992 25.4317 20.4835 26.0481 20.8321C26.6644 21.1807 27.1745 21.681 27.5264 22.2823V22.2827Z",
    fill: "url(#paint3_radial_256_892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0221 22.7654C24.0089 22.9583 23.305 23.6236 23.0589 23.6236C20.7815 23.6236 20.4116 24.9577 20.4116 24.9577C20.5125 26.0811 21.3209 27.0068 22.2982 27.4951C22.3428 27.5175 22.3881 27.5377 22.4334 27.5575C22.5118 27.5911 22.5901 27.6222 22.6685 27.6507C23.0039 27.7657 23.3552 27.8313 23.7107 27.8454C27.7033 28.0267 28.4763 23.223 25.5952 21.8283C26.2748 21.7426 26.9631 21.9044 27.5265 22.2823C27.1746 21.681 26.6645 21.1806 26.0482 20.8321C25.4318 20.4835 24.7312 20.2992 24.0174 20.2979C23.9223 20.2979 23.8293 20.3055 23.7359 20.3117C22.9322 20.365 22.1638 20.6517 21.5309 21.1343C21.653 21.2343 21.7909 21.368 22.0812 21.6452C22.6247 22.1636 24.0186 22.7007 24.0217 22.7638L24.0221 22.7654Z",
    fill: "url(#paint4_radial_256_892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0221 22.7654C24.0089 22.9583 23.305 23.6236 23.0589 23.6236C20.7815 23.6236 20.4116 24.9577 20.4116 24.9577C20.5125 26.0811 21.3209 27.0068 22.2982 27.4951C22.3428 27.5175 22.3881 27.5377 22.4334 27.5575C22.5118 27.5911 22.5901 27.6222 22.6685 27.6507C23.0039 27.7657 23.3552 27.8313 23.7107 27.8454C27.7033 28.0267 28.4763 23.223 25.5952 21.8283C26.2748 21.7426 26.9631 21.9044 27.5265 22.2823C27.1746 21.681 26.6645 21.1806 26.0482 20.8321C25.4318 20.4835 24.7312 20.2992 24.0174 20.2979C23.9223 20.2979 23.8293 20.3055 23.7359 20.3117C22.9322 20.365 22.1638 20.6517 21.5309 21.1343C21.653 21.2343 21.7909 21.368 22.0812 21.6452C22.6247 22.1636 24.0186 22.7007 24.0217 22.7638L24.0221 22.7654Z",
    fill: "url(#paint5_radial_256_892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1577 20.8782C21.2226 20.9182 21.2761 20.9531 21.323 20.9845C21.1405 20.3659 21.1327 19.7113 21.3005 19.0889C20.5616 19.4354 19.9052 19.9267 19.3726 20.5316C19.4116 20.5306 20.5734 20.5104 21.1577 20.8782Z",
    fill: "url(#paint6_radial_256_892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.072 24.4398C16.6902 27.9757 20.0006 30.6771 23.7577 30.7792C27.2357 30.8744 29.4573 28.9194 30.3749 27.0132C31.1522 25.3647 31.2415 23.4891 30.6241 21.7784V21.771C30.6241 21.7652 30.6228 21.7618 30.6241 21.7636L30.6255 21.7766C30.9097 23.5729 29.9661 25.3125 28.4908 26.4911L28.4862 26.5011C25.6116 28.7683 22.861 27.8686 22.3051 27.5016C22.2662 27.4836 22.2274 27.4649 22.1885 27.4454C20.5127 26.6698 19.8202 25.1922 19.969 23.9235C19.5712 23.9292 19.1802 23.8231 18.8435 23.618C18.5067 23.4129 18.2386 23.1176 18.0717 22.7679C18.5116 22.507 19.0132 22.3595 19.5287 22.3394C20.0442 22.3194 20.5564 22.4275 21.0165 22.6535C21.965 23.0703 23.0441 23.1114 24.0234 22.7679C24.0203 22.7049 22.6264 22.1676 22.0829 21.6493C21.7925 21.3722 21.6547 21.2387 21.5326 21.1385C21.4666 21.0843 21.3976 21.0337 21.3259 20.9868C21.2784 20.9554 21.2249 20.9213 21.1606 20.8805C20.5764 20.5127 19.4145 20.5329 19.3761 20.5339H19.3724C19.0549 20.1443 19.0773 18.8597 19.0954 18.5913C19.0015 18.6279 18.9119 18.6739 18.828 18.7288C18.5478 18.9224 18.2858 19.1397 18.0452 19.3781C17.77 19.6466 17.5185 19.9369 17.2934 20.246C16.7785 20.9527 16.4133 21.7509 16.2188 22.595C16.2148 22.6108 15.9303 23.8155 16.0706 24.4402L16.072 24.4398Z",
    fill: "url(#paint7_radial_256_892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8325 21.3784C27.1249 21.6565 27.3754 21.9731 27.5765 22.3189C27.6205 22.3511 27.6617 22.3832 27.6966 22.4142C29.5125 24.035 28.561 26.3262 28.4901 26.4883C29.9653 25.3115 30.908 23.5708 30.6249 21.7738C29.7189 19.5867 28.1822 18.7042 26.9299 16.7852C26.8664 16.6881 26.803 16.5909 26.7412 16.4882C26.7059 16.4296 26.6775 16.3768 26.653 16.3282C26.6009 16.2306 26.5609 16.1275 26.5335 16.021C26.5335 16.0161 26.5317 16.0113 26.5284 16.0076C26.525 16.0039 26.5204 16.0016 26.5153 16.001C26.5104 15.9997 26.5052 15.9997 26.5002 16.001C26.4992 16.001 26.4975 16.0028 26.4963 16.0032C26.4951 16.0036 26.4924 16.0054 26.4905 16.0062C26.1807 16.1485 24.3433 18.9658 26.8336 21.375L26.8325 21.3784Z",
    fill: "url(#paint8_radial_256_892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.696 22.4147C27.661 22.3837 27.6199 22.3517 27.5759 22.3195C27.5596 22.3077 27.5435 22.2959 27.5261 22.284C26.9627 21.9062 26.2745 21.7444 25.5949 21.83C28.4757 23.2247 27.7028 28.0273 23.7104 27.8472C23.3549 27.833 23.0036 27.7674 22.6682 27.6525C22.5898 27.6241 22.5114 27.593 22.433 27.5592C22.3877 27.5392 22.3425 27.5192 22.2979 27.4968L22.3034 27.5002C22.8602 27.8682 25.61 28.7673 28.4846 26.4997L28.4891 26.4897C28.5608 26.3276 29.5123 24.0364 27.6956 22.4155L27.696 22.4147Z",
    fill: "url(#paint9_radial_256_892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4115 24.9562C20.4115 24.9562 20.7813 23.6221 23.0588 23.6221C23.305 23.6221 24.0095 22.9568 24.0221 22.7639C23.0428 23.1073 21.9636 23.0663 21.0152 22.6494C20.5551 22.4234 20.0429 22.3153 19.5274 22.3354C19.0119 22.3554 18.5102 22.5029 18.0703 22.7639C18.2373 23.1135 18.5054 23.4088 18.8421 23.6139C19.1789 23.819 19.5698 23.9252 19.9676 23.9195C19.8193 25.1876 20.5116 26.6649 22.1872 27.4413C22.2246 27.4588 22.2597 27.4776 22.2981 27.4942C21.32 27.0049 20.5124 26.0796 20.4115 24.9568V24.9562Z",
    fill: "url(#paint10_radial_256_892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4201 21.3725C31.0721 20.5617 30.3661 19.6862 29.8133 19.4095C30.2075 20.1487 30.4811 20.9425 30.6244 21.7627L30.6259 21.7757C29.7203 19.5906 28.1853 18.7081 26.9308 16.7891C26.8674 16.6921 26.804 16.5948 26.7422 16.4921C26.7068 16.4335 26.6785 16.3807 26.6539 16.3321C26.6019 16.2345 26.5618 16.1314 26.5345 16.0249C26.5345 16.02 26.5327 16.0152 26.5293 16.0115C26.526 16.0078 26.5213 16.0055 26.5163 16.0049C26.5114 16.0036 26.5061 16.0036 26.5012 16.0049C26.5002 16.0049 26.4985 16.0067 26.4973 16.0071C26.496 16.0075 26.4934 16.0093 26.4915 16.0101L26.4946 16.0049C24.4828 17.1455 23.7998 19.2566 23.7378 20.3132C23.8312 20.307 23.9238 20.2994 24.0192 20.2994C24.733 20.3007 25.4337 20.485 26.05 20.8336C26.6664 21.1821 27.1764 21.6825 27.5283 22.2838C26.9649 21.906 26.2767 21.7441 25.5971 21.8298C28.4779 23.2245 27.705 28.0271 23.7126 27.847C23.3571 27.8328 23.0058 27.7672 22.6704 27.6523C22.592 27.6238 22.5136 27.5928 22.4352 27.559C22.3899 27.539 22.3447 27.519 22.3001 27.4966L22.3056 27.5C22.2668 27.482 22.2279 27.4632 22.1891 27.4437C22.2265 27.4612 22.2616 27.48 22.3001 27.4966C21.3219 27.0071 20.5143 26.0818 20.4135 24.9592C20.4135 24.9592 20.7832 23.6251 23.0608 23.6251C23.3069 23.6251 24.0114 22.9598 24.024 22.7669C24.0209 22.7038 22.627 22.1666 22.0835 21.6483C21.7931 21.3711 21.6553 21.2377 21.5331 21.1374C21.4671 21.0833 21.3981 21.0326 21.3265 20.9857C21.144 20.3672 21.1362 19.7126 21.304 19.0901C20.5651 19.4367 19.9086 19.928 19.376 20.5329H19.3723C19.0549 20.1433 19.0772 18.8586 19.0954 18.5903C19.0015 18.6268 18.9119 18.6729 18.828 18.7277C18.5478 18.9214 18.2858 19.1387 18.0452 19.3771C17.7709 19.6463 17.5205 19.9372 17.2964 20.2469C16.7816 20.9536 16.4163 21.7519 16.2218 22.596L16.2111 22.6472C16.196 22.7154 16.1284 23.062 16.1187 23.1365C16.0569 23.4942 16.0174 23.8553 16.0005 24.2176V24.2577C16.004 26.1984 16.7588 28.0673 18.1159 29.4955C19.473 30.9237 21.3337 31.8074 23.3308 31.9721C25.3278 32.1368 27.3161 31.5706 28.9031 30.3852C30.49 29.1998 31.5604 27.4814 31.9028 25.5692C31.9163 25.4691 31.9272 25.37 31.9392 25.269C32.1042 23.9487 31.9256 22.6094 31.4197 21.3729L31.4201 21.3725Z",
    fill: "url(#paint11_linear_256_892)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_256_892",
    x1: 30.3599,
    y1: 18.4822,
    x2: 17.4763,
    y2: 31.3197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_256_892",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.8451 17.8043) scale(16.698 16.1686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_256_892",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6453 24.4078) scale(16.698 16.1686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_256_892",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7119 14.2025) scale(12.0957 11.7122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_256_892",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7861 28.6105) scale(7.95014 7.69807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_256_892",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4536 23.0203) rotate(-13.1759) scale(4.20858 4.78747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_256_892",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.4392 17.2043) scale(5.7203 5.53893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_256_892",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.9851 13.6021) scale(24.4063 23.6325)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_256_892",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.9571 14.9126) rotate(83.7803) scale(17.3246 11.7337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_256_892",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.4388 19.205) scale(15.2348 14.7518)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_256_892",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.3656 20.0056) scale(16.6752 16.1465)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_256_892",
    x1: 30.1987,
    y1: 18.4161,
    x2: 19.2507,
    y2: 29.7247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_256_892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFirefoxIcon);
export default __webpack_public_path__ + "static/media/mobile_firefox_icon.9e489bee.svg";
export { ForwardRef as ReactComponent };